// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ---- Sidebar (well panel) — shared tokens ---- */
.leftbar {
  /* No backdrop-filter here: it creates a containing block for descendants, so
     position:fixed .modal overlays (datalog / imputation / etc.) get trapped
     inside this narrow panel instead of covering the viewport. */
  --lb-bg: rgba(255, 255, 255, 0.985);
  --lb-surface: rgba(248, 251, 253, 0.98);
  --lb-border: rgba(21, 52, 72, 0.1);
  --lb-text: #1c2d38;
  --lb-muted: #5c6f7c;
  --lb-accent: #1e5278;
  --lb-radius: 12px;
  --lb-shadow: 0 4px 28px rgba(21, 52, 72, 0.07);
  --lb-font: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;

  position: fixed;
  top: 0;
  box-sizing: border-box;
  font-family: var(--lb-font);
  width: min(400px, 100vw);
  height: 100%;
  background: var(--lb-bg);
  border-right: 1px solid var(--lb-border);
  box-shadow: var(--lb-shadow);
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  overflow: hidden;
  color: var(--lb-text);
}

/* Pages that use .leftbar without .leftbar-inner (e.g. saved.js) */
.leftbar:not(:has(.leftbar-inner)) {
  padding: 1rem;
  overflow-x: auto;
  overflow-y: auto;
}

.leftbar-inner {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  width: 100%;
}

.leftbar-toolbar {
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--lb-border);
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.55) 0%,
    rgba(237, 244, 250, 0.35) 100%
  );
}

.leftbar .leftbar-close-btn {
  margin: 0;
  padding: 0.45rem 0.85rem;
  font-size: 0.8125rem;
  font-weight: 600;
  font-family: var(--lb-font);
  letter-spacing: 0.02em;
  color: #6b2c2c;
  background: rgba(254, 242, 242, 0.95);
  border: 1px solid rgba(185, 28, 28, 0.22);
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
}

.leftbar .leftbar-close-btn:hover {
  background: #fff;
  border-color: rgba(185, 28, 28, 0.35);
  box-shadow: 0 2px 8px rgba(185, 28, 28, 0.08);
}

.leftbar-content {
  flex: 1 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 1.125rem;
  padding: 1rem 1rem 1.5rem;
  margin-bottom: 0;
  -webkit-overflow-scrolling: touch;
}

/* Well summary card (map sidebar) */
.leftbar-well-card {
  background: var(--lb-surface);
  border: 1px solid var(--lb-border);
  border-radius: var(--lb-radius);
  padding: 1rem 1.1rem;
  box-shadow: 0 1px 3px rgba(21, 52, 72, 0.04);
}

.leftbar-well-card__head {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 1rem;
  padding-bottom: 0.875rem;
  border-bottom: 1px solid var(--lb-border);
}

.leftbar-well-card__icon {
  flex-shrink: 0;
  width: 1.25rem;
  height: 1.25rem;
  margin-top: 0.2rem;
  color: var(--lb-accent);
}

.leftbar-well-card__title {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.2;
  color: var(--lb-accent);
}

.leftbar-well-card__subtitle {
  margin: 0.2rem 0 0;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--lb-muted);
}

.leftbar-meta {
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.leftbar-meta__row {
  display: grid;
  grid-template-columns: 5.5rem 1fr;
  gap: 0.5rem 0.75rem;
  padding: 0.5rem 0;
  border-bottom: 1px solid rgba(21, 52, 72, 0.06);
  align-items: baseline;
}

.leftbar-meta__row:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.leftbar-meta__row:first-of-type {
  padding-top: 0;
}

.leftbar-meta dt {
  margin: 0;
  font-size: 0.6875rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--lb-muted);
}

.leftbar-meta dd {
  margin: 0;
  font-size: 0.9375rem;
  font-weight: 500;
  line-height: 1.35;
  color: var(--lb-text);
  word-break: break-word;
}

/* Action buttons grid */
.leftbar-actions {
  margin-top: 0.25rem;
}

.leftbar-actions__label {
  margin: 0 0 0.65rem;
  font-size: 0.6875rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--lb-muted);
}

.leftbar-actions__grid {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.leftbar .leftbar-btn {
  margin: 0;
  width: 100%;
  box-sizing: border-box;
  padding: 0.6rem 1rem;
  font-size: 0.875rem;
  font-weight: 600;
  font-family: var(--lb-font);
  text-align: left;
  color: var(--lb-text);
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid rgba(30, 82, 120, 0.2);
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(21, 52, 72, 0.04);
  transition: background 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease,
    transform 0.12s ease;
}

.leftbar .leftbar-btn:hover {
  background: rgba(237, 244, 250, 0.98);
  border-color: rgba(30, 82, 120, 0.32);
  box-shadow: 0 2px 10px rgba(21, 52, 72, 0.07);
}

.leftbar .leftbar-btn:active {
  transform: translateY(1px);
}

/* Slim accent strip — unified, low-contrast */
.leftbar-btn--raw,
.leftbar-btn--purified,
.leftbar-btn--impute,
.leftbar-btn--anomaly,
.leftbar-btn--forecast {
  border-left: 3px solid rgba(30, 82, 120, 0.4);
}

/* Legacy header (e.g. saved.js) */
.leftbar-header {
  font-size: 1.125rem;
  color: var(--lb-accent);
  font-weight: 700;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  padding: 0.85rem 1rem;
  background-color: var(--lb-surface);
  border-radius: var(--lb-radius);
  box-shadow: 0 1px 3px rgba(21, 52, 72, 0.05);
  border: 1px solid var(--lb-border);
  transition: background-color 0.2s ease;
}

.leftbar-header:hover {
  background-color: rgba(237, 244, 250, 0.95);
}

.leftbar-header .highlight {
  color: var(--lb-accent);
  text-transform: capitalize;
  font-weight: 700;
  margin-left: 0.35rem;
  margin-right: 0.35rem;
}

.leftbar-header .fa-map-marker {
  color: var(--lb-accent);
  margin-right: 0.5rem;
}

/* Legacy well block (e.g. saved.js) */
.well-info p {
  background-color: rgba(237, 244, 250, 0.65);
  color: var(--lb-text);
  border-radius: var(--lb-radius);
  font-size: 0.9375rem;
  box-shadow: 0 1px 3px rgba(21, 52, 72, 0.05);
  border: 1px solid var(--lb-border);
  padding: 1rem;
  margin-bottom: 0.75rem;
  line-height: 1.45;
}

/* Location Section */
.location-info h2 {
  color: #3f9b9b;
  font-size: 20px;
  margin-top: 10px;
}

.location-info p {
  font-size: 20px;
  color: #555;
}

.location-info strong {
  font-weight: bold;
  color: #2b3a42;
}

.datalog-button {
  background-color: #1f4620; /* Green background */
  color: white;
  padding: 15px 60px;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  cursor: pointer;
  margin-top: 10px;
  display: block;
}

.do-imputation {
  background-color: #c75c0b;
  color: white;
  padding: 15px 70px;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  cursor: pointer;
  margin-top: 10px;
  display: block;
}
/* .rateTextField {
  background-color: #bfaeae;
  color: rgb(7, 7, 7);
  padding: 12px 50px;
  
  border-radius: 6px;
  font-size: 18px;
  cursor: pointer;
  margin-top: 20px;
  display: block;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); 
  
} */

.anomaly {
  background-color: #c70b3a;
  color: white;
  padding: 15px 60px;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  cursor: pointer;
  margin-top: 10px;
  display: block;
}

/* No Marker Selected */
.no-marker {
  text-align: center;
  color: #b0bec5;
  font-size: 15px;
  font-weight: 500;
}

.no-marker h2 {
  color: #ff6f60; /* Soft Red for no selection message */
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1099;
}

/* Modal Container — sits above navbar (z-index 1000) and leftbar (z-index 900) */
.modal {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1300; /* match MUI default so it's always above navbar */
  overflow-y: auto;
  padding: 80px 1rem 1rem; /* top padding clears the fixed navbar (~80px) */
  box-sizing: border-box;
}

/* Modal Row — constrained width, no fixed height */
.modal-row {
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  align-items: flex-start;
}

/* Modal Content — base card */
.modal-content {
  padding: 16px;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  flex: 1 1;
  z-index: 1301;
  box-sizing: border-box;
}

/* Left Content */
.modal-content.left-content {
  flex: 2 1;
  max-width: 65%;
  overflow-y: auto;
  max-height: calc(100vh - 100px); /* stay within viewport */
  padding-right: 10px;
}

/* Right Content */
.modal-content.right-content {
  flex: 1 1;
  max-width: 35%;
  overflow-y: auto;
  max-height: calc(100vh - 100px);
  padding-right: 16px;
  padding-left: 16px;
}



/* Button Group */
.button-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

/* Button Styles */
.button {
  font-size: 16px;
  padding: 10px 20px;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s ease;
}

.button:hover {
  opacity: 0.9;
}

.blue-button {
  background-color: #2196f3 !important;
  color: #ffffff !important;
}

.green-button {
  background-color: #4caf50 !important;
  color: #ffffff !important;
}

.red-button {
  background-color: #ff0000 !important;
  color: #ffffff !important;
  text-align: right;
}

.clear-button {
  background-color: #ff9800 !important; /* Orange color */
  color: #ffffff !important;
}

.clear-button:hover {
  opacity: 0.9;
}

/* Input Group */
.input-group {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-top: 20px;
}

.input-group h3 {
  margin: 0;

  color: #0e2a58; /* Adjust the color as needed */
}

/* Rate Text Field */
.rate-text-field {
  background-color: #e0e0e0;
  color: #000000;
  cursor: pointer;
  margin-top: 25px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  padding: 4px;
  width: 200px;
}
.missing-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}
.missing-container h3 {
  margin: 0;
  color: #000000; /* Adjust the color as needed */
}

.toggle-group-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

.toggle-group-container h3 {
  margin: 0;
  color: #000000; /* Adjust the color as needed */
}

/* Toggle Button Group */
.toggle-button-group {
  background-color: #f0f0f0;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.toggle-button-group .MuiToggleButton-root {
  color: #000000;
  border: none;
  transition: background-color 0.3s ease;
}

.toggle-button-group .Mui-selected {
  background-color: #6d103c !important;
  color: #ffffff !important;
}

/* Selected Info */
.selected-info {
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 20px;
  color: #000000;
}

/* Submit Button */
.submit-button {
  background-color: #85126e !important;
  color: #ffffff !important;
  padding: 12px 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  margin-left: 25px;
  transition: background-color 0.3s ease;
}

.submit-button:hover {
  opacity: 0.9;
}

.action-button {
  background-color: #1f4620 !important; /* Green background */
  color: white !important;
  padding: 15px 60px;
  border: none;
  border-radius: 6px;
  font-size: 21px;
  cursor: pointer;
  margin-top: 20px;
  display: block;
}

.action-button:hover {
  opacity: 0.9;
}

/* Modal Header */
.modal-content h2 {
  color: #023d5e;
  font-size: 40px;
  margin-bottom: 20px;
  text-align: center;
}

.modal-content p {
  color: #023d5e;
  font-size: 15px;
  margin-bottom: 10px;
  text-align: left;
}

/* .modal-content button {
  background-color: #4caf50; 
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 10px;
  display: block;
  margin-left: auto; 
} */
/* 
.modal-content button:hover {
  background-color: #45a049; 
} */
*/

/* Modal Datalog Content */
.datalog {
  color: #4a4a4a; /* Dark text for readability */
  font-size: 14px;
  max-height: 300px; /* Limit modal height */
  overflow-y: auto; /* Scrollable if content exceeds height */
  padding: 10px;
}
/* .loading-modal {
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-content {
  background-color: #ffffff;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
  text-align: center;
  font-size: 18px;
  color: #000000;
} */

.loading-modal {
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-content {
  background: linear-gradient(
    175deg,
    #ffffff,
    #a6d7ff
  ); /* Subtle gradient background */
  padding: 40px;
  border-radius: 15px;
  box-shadow: 0 10px 20px rgba(0, 140, 255, 0.3);
  text-align: center;
  font-size: 20px;

  animation: fadeIn 0.5s ease-in-out;
}

.loading-content p {
  margin: 0 0 20px;
  font-size: 24px;
  font-weight: bold;
  color: #000000; /* Match the theme color */
}

.loading-content .progress-bar {
  width: 100%;
  background-color: #060708;
  border-radius: 8px;
  overflow: hidden;
  height: 10px;
  margin-top: 20px;
}

.loading-content .progress {
  width: 0;
  height: 100%;
  background: linear-gradient(90deg, #2196f3 25%, #21d4fd 50%, #2196f3 75%);
  animation: progress-animation 5s linear forwards;
}

@keyframes wave-animation {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

@keyframes progress-animation {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}
.model-weights {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 15px;
  margin-top: 20px;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.model-weights h3 {
  flex-basis: 100%;
  margin: 0 0 10px;
  color: #85126e; /* Match the theme color */
  font-size: 18px;
  font-weight: bold;
}
.weight-input {
  background-color: #ffffff;
  color: #000000;
  font-size: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  padding: 10px;
  flex: 1 1;
  min-width: 150px; /* Ensure a minimum width for the input fields */
}
.graph-container {
  padding: 20px;
  background-color: #f9f9f9; /* Light background color */
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow */
  margin: 20px 0; /* Space around the container */
  width: 100%; /* Full width */
}

.graph-container h3 {
  color: #85126e; /* Match the theme color */
  font-size: 18px;
  font-weight: bold;
  margin: 0 0 10px;
}

.button.download-button {
  margin-bottom: 20px; /* Space below the button */
  background-color: #ffc400; /* Green background */
  color: white; /* White text */
}

.chart-wrapper {
  background-color: white; /* White background for the chart */
  padding: 50px;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow */
}

.region {
  padding: 20px;
  background-color: #000000;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 190px;
}

.region-header {
  font-size: 2em;
}

.region-header .highlight {
  font-weight: bold;
  margin-bottom: 25px;
}

.region ul {
  list-style-type: none;
  padding: 0;
}

.region ul li {
  font-size: 1em;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.region ul li span {
  font-weight: bold;
}
.color-box {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  border: 1px solid #000;
}

button {
  margin-left: 10px;
  padding: 5px 10px;
  border: none;
  background-color: #57687a;
  color: rgb(0, 0, 0);
  cursor: pointer;
  border-radius: 4px;
}

button:hover {
  background-color: #00b395;
}

.clear-button {
  margin-left: 10px;
  padding: 5px 10px;
  border: none;
  background-color: #dc3545;
  color: white;
  cursor: pointer;
  border-radius: 4px;
}

.clear-button:hover {
  background-color: #c82333;
}

.selected-regions {
  margin-top: 20px;
}

.selected-regions h2 {
  font-size: 1.2em;
  margin-bottom: 10px;
}

.selected-regions ul {
  list-style-type: none;
  padding: 0;
}

.selected-regions ul li {
  margin-bottom: 5px;
}

.back-button {
  margin-bottom: 10px;
  padding: 5px 10px;
  border: none;
  background-color: #007bff;
  color: white;
  cursor: pointer;
  border-radius: 4px;
}

.back-button:hover {
  background-color: #0056b3;
}

.region-list-container {
  padding: 20px;
  background-color: #000000;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
}

.region-list-container button {
  margin-bottom: 10px;
  padding: 10px 20px;
  border: none;
  background-color: #c97611;

  cursor: pointer;
  border-radius: 4px;
}

.region-list-container button:hover {
  background-color: #0056b3;
}

.region-list-container h2 {
  font-size: 1.5em;
  margin-bottom: 10px;
  color: #ffffff;
}

.region-list {
  list-style-type: none;
  padding: 0;
}

.region-list li {
  font-size: 1.2em;
  margin-bottom: 5px;
  padding: 10px;
  background-color: #2b2929;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(39, 12, 12, 0.1);
}

.region-info {
  padding: 20px;
  background-color: #6c4646;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
}

.region-info button {
  margin-bottom: 10px;
  padding: 10px 20px;
  border: none;
  background-color: #320306;
  color: white;
  cursor: pointer;
  border-radius: 4px;
}

.region-info button:hover {
  background-color: #a85470;
}

.region-info h2 {
  font-size: 2em;
  margin-bottom: 10px;
  color: #0c0000;
}

.region-info p {
  font-size: 1.2em;
  color: #000000;
  line-height: 1.5;
}

.filter-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 80%; /* Matches slider width */
  margin: 10px auto;
  gap: 10px;
}

.filter-label {
  font-size: 16px;
  font-weight: bold;
  color: #000000;
}

.filter-dropdown {
  flex: 1 1; /* Makes it take the same width as the slider */
  min-width: 150px;
}

.button-group {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px; /* Space between buttons */
  margin: 10px auto;
  width: 100%;
}

.zoom-button {
  flex: 1 1; /* Equal width for all buttons */
  min-width: 120px; /* Ensures buttons are not too small */
  text-transform: none; /* Keeps text as entered (not uppercase) */
  font-size: 12px;
  font-weight: 500;
  padding: 8px 12px;
}
.table-filter-container {
  display: flex;
  justify-content: flex-end; /* Align filter to the right */
  margin-bottom: 10px;
}

.table-filter-dropdown {
  min-width: 150px;
}
/* Help Modal Styling */
.help-modal-container {
  width: 30%;
  margin: 5% auto;
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  max-height: 80vh;
  overflow-y: auto;
  text-align: left;
 
}

/* Modal Header */
.help-modal-container h5 {
  text-align: center;
  margin-bottom: 15px;
  color: #000000;
  font-weight: bold;
}

/* Modal Sections */
.help-modal-container h6 {
  margin-top: 20px;
  color: #007bff;
  font-weight: bold;
}

/* Bullet Points */
.help-modal-container ul {
  padding-left: 20px;
  margin: 10px 0;
}

.help-modal-container li {
  margin-bottom: 8px;
  font-size: 16px;
  color: #000000;
}

/* Close Button */
.help-modal-close {
  text-align: right;
  margin-top: 15px;
}

.help-modal-close button {
  background-color: #d32f2f;
  color: white;
  font-weight: bold;
  padding: 8px 16px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  transition: background 0.3s ease-in-out;
}

.help-modal-close button:hover {
  background-color: #b71c1c;
}
.purified-button {
  background-color: #183792; /* Green background */
  color: white;
  padding: 15px 60px;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  cursor: pointer;
  margin-top: 10px;
  display: block;
}

.forecast {
  background-color: #d600a8;
  color: white;
  padding: 15px 70px;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  cursor: pointer;
  margin-top: 10px;
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/leftbar.css"],"names":[],"mappings":"AAAA,mDAAmD;AACnD;EACE;;iEAE+D;EAC/D,mCAAmC;EACnC,uCAAuC;EACvC,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,8CAA8C;EAC9C,4FAA4F;;EAE5F,eAAe;EACf,MAAM;EACN,sBAAsB;EACtB,2BAA2B;EAC3B,wBAAwB;EACxB,YAAY;EACZ,wBAAwB;EACxB,wCAAwC;EACxC,4BAA4B;EAC5B,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;EACzC;;;;GAIC;AACH;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;EACtB,cAAc;EACd,qCAAqC;EACrC,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,oCAAoC;AACpC;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,+BAA+B;EAC/B,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,mBAAmB;EACnB,iBAAiB;EACjB,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;EACrB,qCAAqC;EACrC,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,4CAA4C;EAC5C;wBACsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,8CAA8C;AAC9C;;;;;EAKE,6CAA6C;AAC/C;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,mCAAmC;EACnC,+BAA+B;EAC/B,4CAA4C;EAC5C,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA,sCAAsC;AACtC;EACE,2CAA2C;EAC3C,qBAAqB;EACrB,+BAA+B;EAC/B,oBAAoB;EACpB,4CAA4C;EAC5C,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB,EAAE,qBAAqB;EAChD,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;;;;;;;;;;;;GAYG;;AAEH;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc,EAAE,sCAAsC;AACxD;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;AACf;;AAEA,iFAAiF;AACjF;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa,EAAE,kDAAkD;EACjE,gBAAgB;EAChB,uBAAuB,EAAE,gDAAgD;EACzE,sBAAsB;AACxB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,cAAc;EACd,gBAAgB;EAChB,+BAA+B,EAAE,yBAAyB;EAC1D,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,cAAc;EACd,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;;;AAIA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC,EAAE,iBAAiB;EACvD,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAS;;EAET,cAAc,EAAE,+BAA+B;AACjD;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,SAAS;EACT,cAAc,EAAE,+BAA+B;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAc,EAAE,+BAA+B;AACjD;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC,EAAE,qBAAqB;EAC3D,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;;;;;;;;;GAWG;AACH;;;GAGG;AACH;;;;EAIE,cAAc,EAAE,8BAA8B;EAC9C,eAAe;EACf,iBAAiB,EAAE,uBAAuB;EAC1C,gBAAgB,EAAE,yCAAyC;EAC3D,aAAa;AACf;AACA;;;;;;;;;;;;;;GAcG;;AAEH;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;;;;GAIC,EAAE,+BAA+B;EAClC,aAAa;EACb,mBAAmB;EACnB,8CAA8C;EAC9C,kBAAkB;EAClB,eAAe;;EAEf,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc,EAAE,0BAA0B;AAC5C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,YAAY;EACZ,yEAAyE;EACzE,gDAAgD;AAClD;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,QAAQ;EACV;EACA;IACE,WAAW;EACb;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc,EAAE,0BAA0B;EAC1C,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,SAAO;EACP,gBAAgB,EAAE,gDAAgD;AACpE;AACA;EACE,aAAa;EACb,yBAAyB,EAAE,2BAA2B;EACtD,mBAAmB;EACnB,wCAAwC,EAAE,kBAAkB;EAC5D,cAAc,EAAE,+BAA+B;EAC/C,WAAW,EAAE,eAAe;AAC9B;;AAEA;EACE,cAAc,EAAE,0BAA0B;EAC1C,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB,EAAE,2BAA2B;EAChD,yBAAyB,EAAE,qBAAqB;EAChD,YAAY,EAAE,eAAe;AAC/B;;AAEA;EACE,uBAAuB,EAAE,mCAAmC;EAC5D,aAAa;EACb,mBAAmB;EACnB,wCAAwC,EAAE,kBAAkB;AAC9D;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;;EAEzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU,EAAE,yBAAyB;EACrC,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO,EAAE,+CAA+C;EACxD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS,EAAE,0BAA0B;EACrC,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,SAAO,EAAE,gCAAgC;EACzC,gBAAgB,EAAE,sCAAsC;EACxD,oBAAoB,EAAE,0CAA0C;EAChE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,yBAAyB,EAAE,8BAA8B;EACzD,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;AACA,uBAAuB;AACvB;EACE,UAAU;EACV,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;;AAElB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB,EAAE,qBAAqB;EAChD,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":["/* ---- Sidebar (well panel) — shared tokens ---- */\n.leftbar {\n  /* No backdrop-filter here: it creates a containing block for descendants, so\n     position:fixed .modal overlays (datalog / imputation / etc.) get trapped\n     inside this narrow panel instead of covering the viewport. */\n  --lb-bg: rgba(255, 255, 255, 0.985);\n  --lb-surface: rgba(248, 251, 253, 0.98);\n  --lb-border: rgba(21, 52, 72, 0.1);\n  --lb-text: #1c2d38;\n  --lb-muted: #5c6f7c;\n  --lb-accent: #1e5278;\n  --lb-radius: 12px;\n  --lb-shadow: 0 4px 28px rgba(21, 52, 72, 0.07);\n  --lb-font: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n\n  position: fixed;\n  top: 0;\n  box-sizing: border-box;\n  font-family: var(--lb-font);\n  width: min(400px, 100vw);\n  height: 100%;\n  background: var(--lb-bg);\n  border-right: 1px solid var(--lb-border);\n  box-shadow: var(--lb-shadow);\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: stretch;\n  overflow: hidden;\n  color: var(--lb-text);\n}\n\n/* Pages that use .leftbar without .leftbar-inner (e.g. saved.js) */\n.leftbar:not(:has(.leftbar-inner)) {\n  padding: 1rem;\n  overflow-x: auto;\n  overflow-y: auto;\n}\n\n.leftbar-inner {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  width: 100%;\n}\n\n.leftbar-toolbar {\n  flex-shrink: 0;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid var(--lb-border);\n  background: linear-gradient(\n    180deg,\n    rgba(255, 255, 255, 0.55) 0%,\n    rgba(237, 244, 250, 0.35) 100%\n  );\n}\n\n.leftbar .leftbar-close-btn {\n  margin: 0;\n  padding: 0.45rem 0.85rem;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  font-family: var(--lb-font);\n  letter-spacing: 0.02em;\n  color: #6b2c2c;\n  background: rgba(254, 242, 242, 0.95);\n  border: 1px solid rgba(185, 28, 28, 0.22);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.leftbar .leftbar-close-btn:hover {\n  background: #fff;\n  border-color: rgba(185, 28, 28, 0.35);\n  box-shadow: 0 2px 8px rgba(185, 28, 28, 0.08);\n}\n\n.leftbar-content {\n  flex: 1;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 1.125rem;\n  padding: 1rem 1rem 1.5rem;\n  margin-bottom: 0;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Well summary card (map sidebar) */\n.leftbar-well-card {\n  background: var(--lb-surface);\n  border: 1px solid var(--lb-border);\n  border-radius: var(--lb-radius);\n  padding: 1rem 1.1rem;\n  box-shadow: 0 1px 3px rgba(21, 52, 72, 0.04);\n}\n\n.leftbar-well-card__head {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n  padding-bottom: 0.875rem;\n  border-bottom: 1px solid var(--lb-border);\n}\n\n.leftbar-well-card__icon {\n  flex-shrink: 0;\n  width: 1.25rem;\n  height: 1.25rem;\n  margin-top: 0.2rem;\n  color: var(--lb-accent);\n}\n\n.leftbar-well-card__title {\n  margin: 0;\n  font-size: 1.35rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n  color: var(--lb-accent);\n}\n\n.leftbar-well-card__subtitle {\n  margin: 0.2rem 0 0;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--lb-muted);\n}\n\n.leftbar-meta {\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.leftbar-meta__row {\n  display: grid;\n  grid-template-columns: 5.5rem 1fr;\n  gap: 0.5rem 0.75rem;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid rgba(21, 52, 72, 0.06);\n  align-items: baseline;\n}\n\n.leftbar-meta__row:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.leftbar-meta__row:first-of-type {\n  padding-top: 0;\n}\n\n.leftbar-meta dt {\n  margin: 0;\n  font-size: 0.6875rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--lb-muted);\n}\n\n.leftbar-meta dd {\n  margin: 0;\n  font-size: 0.9375rem;\n  font-weight: 500;\n  line-height: 1.35;\n  color: var(--lb-text);\n  word-break: break-word;\n}\n\n/* Action buttons grid */\n.leftbar-actions {\n  margin-top: 0.25rem;\n}\n\n.leftbar-actions__label {\n  margin: 0 0 0.65rem;\n  font-size: 0.6875rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  color: var(--lb-muted);\n}\n\n.leftbar-actions__grid {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.leftbar .leftbar-btn {\n  margin: 0;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0.6rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  font-family: var(--lb-font);\n  text-align: left;\n  color: var(--lb-text);\n  background: rgba(255, 255, 255, 0.98);\n  border: 1px solid rgba(30, 82, 120, 0.2);\n  border-radius: 8px;\n  cursor: pointer;\n  box-shadow: 0 1px 2px rgba(21, 52, 72, 0.04);\n  transition: background 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease,\n    transform 0.12s ease;\n}\n\n.leftbar .leftbar-btn:hover {\n  background: rgba(237, 244, 250, 0.98);\n  border-color: rgba(30, 82, 120, 0.32);\n  box-shadow: 0 2px 10px rgba(21, 52, 72, 0.07);\n}\n\n.leftbar .leftbar-btn:active {\n  transform: translateY(1px);\n}\n\n/* Slim accent strip — unified, low-contrast */\n.leftbar-btn--raw,\n.leftbar-btn--purified,\n.leftbar-btn--impute,\n.leftbar-btn--anomaly,\n.leftbar-btn--forecast {\n  border-left: 3px solid rgba(30, 82, 120, 0.4);\n}\n\n/* Legacy header (e.g. saved.js) */\n.leftbar-header {\n  font-size: 1.125rem;\n  color: var(--lb-accent);\n  font-weight: 700;\n  margin-bottom: 1rem;\n  display: flex;\n  align-items: center;\n  padding: 0.85rem 1rem;\n  background-color: var(--lb-surface);\n  border-radius: var(--lb-radius);\n  box-shadow: 0 1px 3px rgba(21, 52, 72, 0.05);\n  border: 1px solid var(--lb-border);\n  transition: background-color 0.2s ease;\n}\n\n.leftbar-header:hover {\n  background-color: rgba(237, 244, 250, 0.95);\n}\n\n.leftbar-header .highlight {\n  color: var(--lb-accent);\n  text-transform: capitalize;\n  font-weight: 700;\n  margin-left: 0.35rem;\n  margin-right: 0.35rem;\n}\n\n.leftbar-header .fa-map-marker {\n  color: var(--lb-accent);\n  margin-right: 0.5rem;\n}\n\n/* Legacy well block (e.g. saved.js) */\n.well-info p {\n  background-color: rgba(237, 244, 250, 0.65);\n  color: var(--lb-text);\n  border-radius: var(--lb-radius);\n  font-size: 0.9375rem;\n  box-shadow: 0 1px 3px rgba(21, 52, 72, 0.05);\n  border: 1px solid var(--lb-border);\n  padding: 1rem;\n  margin-bottom: 0.75rem;\n  line-height: 1.45;\n}\n\n/* Location Section */\n.location-info h2 {\n  color: #3f9b9b;\n  font-size: 20px;\n  margin-top: 10px;\n}\n\n.location-info p {\n  font-size: 20px;\n  color: #555;\n}\n\n.location-info strong {\n  font-weight: bold;\n  color: #2b3a42;\n}\n\n.datalog-button {\n  background-color: #1f4620; /* Green background */\n  color: white;\n  padding: 15px 60px;\n  border: none;\n  border-radius: 6px;\n  font-size: 15px;\n  cursor: pointer;\n  margin-top: 10px;\n  display: block;\n}\n\n.do-imputation {\n  background-color: #c75c0b;\n  color: white;\n  padding: 15px 70px;\n  border: none;\n  border-radius: 6px;\n  font-size: 15px;\n  cursor: pointer;\n  margin-top: 10px;\n  display: block;\n}\n/* .rateTextField {\n  background-color: #bfaeae;\n  color: rgb(7, 7, 7);\n  padding: 12px 50px;\n  \n  border-radius: 6px;\n  font-size: 18px;\n  cursor: pointer;\n  margin-top: 20px;\n  display: block;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); \n  \n} */\n\n.anomaly {\n  background-color: #c70b3a;\n  color: white;\n  padding: 15px 60px;\n  border: none;\n  border-radius: 6px;\n  font-size: 15px;\n  cursor: pointer;\n  margin-top: 10px;\n  display: block;\n}\n\n/* No Marker Selected */\n.no-marker {\n  text-align: center;\n  color: #b0bec5;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.no-marker h2 {\n  color: #ff6f60; /* Soft Red for no selection message */\n}\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1099;\n}\n\n/* Modal Container — sits above navbar (z-index 1000) and leftbar (z-index 900) */\n.modal {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1300; /* match MUI default so it's always above navbar */\n  overflow-y: auto;\n  padding: 80px 1rem 1rem; /* top padding clears the fixed navbar (~80px) */\n  box-sizing: border-box;\n}\n\n/* Modal Row — constrained width, no fixed height */\n.modal-row {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  width: 100%;\n  max-width: 1400px;\n  margin: 0 auto;\n  align-items: flex-start;\n}\n\n/* Modal Content — base card */\n.modal-content {\n  padding: 16px;\n  background-color: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\n  flex: 1;\n  z-index: 1301;\n  box-sizing: border-box;\n}\n\n/* Left Content */\n.modal-content.left-content {\n  flex: 2;\n  max-width: 65%;\n  overflow-y: auto;\n  max-height: calc(100vh - 100px); /* stay within viewport */\n  padding-right: 10px;\n}\n\n/* Right Content */\n.modal-content.right-content {\n  flex: 1;\n  max-width: 35%;\n  overflow-y: auto;\n  max-height: calc(100vh - 100px);\n  padding-right: 16px;\n  padding-left: 16px;\n}\n\n\n\n/* Button Group */\n.button-group {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n/* Button Styles */\n.button {\n  font-size: 16px;\n  padding: 10px 20px;\n  border-radius: 6px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  transition: background-color 0.3s ease;\n}\n\n.button:hover {\n  opacity: 0.9;\n}\n\n.blue-button {\n  background-color: #2196f3 !important;\n  color: #ffffff !important;\n}\n\n.green-button {\n  background-color: #4caf50 !important;\n  color: #ffffff !important;\n}\n\n.red-button {\n  background-color: #ff0000 !important;\n  color: #ffffff !important;\n  text-align: right;\n}\n\n.clear-button {\n  background-color: #ff9800 !important; /* Orange color */\n  color: #ffffff !important;\n}\n\n.clear-button:hover {\n  opacity: 0.9;\n}\n\n/* Input Group */\n.input-group {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-top: 20px;\n}\n\n.input-group h3 {\n  margin: 0;\n\n  color: #0e2a58; /* Adjust the color as needed */\n}\n\n/* Rate Text Field */\n.rate-text-field {\n  background-color: #e0e0e0;\n  color: #000000;\n  cursor: pointer;\n  margin-top: 25px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  border-radius: 6px;\n  padding: 4px;\n  width: 200px;\n}\n.missing-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n}\n.missing-container h3 {\n  margin: 0;\n  color: #000000; /* Adjust the color as needed */\n}\n\n.toggle-group-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.toggle-group-container h3 {\n  margin: 0;\n  color: #000000; /* Adjust the color as needed */\n}\n\n/* Toggle Button Group */\n.toggle-button-group {\n  background-color: #f0f0f0;\n  border-radius: 6px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.toggle-button-group .MuiToggleButton-root {\n  color: #000000;\n  border: none;\n  transition: background-color 0.3s ease;\n}\n\n.toggle-button-group .Mui-selected {\n  background-color: #6d103c !important;\n  color: #ffffff !important;\n}\n\n/* Selected Info */\n.selected-info {\n  display: flex;\n  align-items: center;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  font-size: 20px;\n  color: #000000;\n}\n\n/* Submit Button */\n.submit-button {\n  background-color: #85126e !important;\n  color: #ffffff !important;\n  padding: 12px 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  border-radius: 6px;\n  margin-left: 25px;\n  transition: background-color 0.3s ease;\n}\n\n.submit-button:hover {\n  opacity: 0.9;\n}\n\n.action-button {\n  background-color: #1f4620 !important; /* Green background */\n  color: white !important;\n  padding: 15px 60px;\n  border: none;\n  border-radius: 6px;\n  font-size: 21px;\n  cursor: pointer;\n  margin-top: 20px;\n  display: block;\n}\n\n.action-button:hover {\n  opacity: 0.9;\n}\n\n/* Modal Header */\n.modal-content h2 {\n  color: #023d5e;\n  font-size: 40px;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.modal-content p {\n  color: #023d5e;\n  font-size: 15px;\n  margin-bottom: 10px;\n  text-align: left;\n}\n\n/* .modal-content button {\n  background-color: #4caf50; \n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  font-size: 16px;\n  cursor: pointer;\n  margin-top: 10px;\n  display: block;\n  margin-left: auto; \n} */\n/* \n.modal-content button:hover {\n  background-color: #45a049; \n} */\n*/\n\n/* Modal Datalog Content */\n.datalog {\n  color: #4a4a4a; /* Dark text for readability */\n  font-size: 14px;\n  max-height: 300px; /* Limit modal height */\n  overflow-y: auto; /* Scrollable if content exceeds height */\n  padding: 10px;\n}\n/* .loading-modal {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.loading-content {\n  background-color: #ffffff;\n  padding: 30px;\n  border-radius: 12px;\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  font-size: 18px;\n  color: #000000;\n} */\n\n.loading-modal {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.loading-content {\n  background: linear-gradient(\n    175deg,\n    #ffffff,\n    #a6d7ff\n  ); /* Subtle gradient background */\n  padding: 40px;\n  border-radius: 15px;\n  box-shadow: 0 10px 20px rgba(0, 140, 255, 0.3);\n  text-align: center;\n  font-size: 20px;\n\n  animation: fadeIn 0.5s ease-in-out;\n}\n\n.loading-content p {\n  margin: 0 0 20px;\n  font-size: 24px;\n  font-weight: bold;\n  color: #000000; /* Match the theme color */\n}\n\n.loading-content .progress-bar {\n  width: 100%;\n  background-color: #060708;\n  border-radius: 8px;\n  overflow: hidden;\n  height: 10px;\n  margin-top: 20px;\n}\n\n.loading-content .progress {\n  width: 0;\n  height: 100%;\n  background: linear-gradient(90deg, #2196f3 25%, #21d4fd 50%, #2196f3 75%);\n  animation: progress-animation 5s linear forwards;\n}\n\n@keyframes wave-animation {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n@keyframes progress-animation {\n  0% {\n    width: 0;\n  }\n  100% {\n    width: 100%;\n  }\n}\n.model-weights {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 15px;\n  margin-top: 20px;\n  padding: 20px;\n  background-color: #f9f9f9;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.model-weights h3 {\n  flex-basis: 100%;\n  margin: 0 0 10px;\n  color: #85126e; /* Match the theme color */\n  font-size: 18px;\n  font-weight: bold;\n}\n.weight-input {\n  background-color: #ffffff;\n  color: #000000;\n  font-size: 10px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border-radius: 6px;\n  padding: 10px;\n  flex: 1;\n  min-width: 150px; /* Ensure a minimum width for the input fields */\n}\n.graph-container {\n  padding: 20px;\n  background-color: #f9f9f9; /* Light background color */\n  border-radius: 12px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow */\n  margin: 20px 0; /* Space around the container */\n  width: 100%; /* Full width */\n}\n\n.graph-container h3 {\n  color: #85126e; /* Match the theme color */\n  font-size: 18px;\n  font-weight: bold;\n  margin: 0 0 10px;\n}\n\n.button.download-button {\n  margin-bottom: 20px; /* Space below the button */\n  background-color: #ffc400; /* Green background */\n  color: white; /* White text */\n}\n\n.chart-wrapper {\n  background-color: white; /* White background for the chart */\n  padding: 50px;\n  border-radius: 12px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow */\n}\n\n.region {\n  padding: 20px;\n  background-color: #000000;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin-bottom: 190px;\n}\n\n.region-header {\n  font-size: 2em;\n}\n\n.region-header .highlight {\n  font-weight: bold;\n  margin-bottom: 25px;\n}\n\n.region ul {\n  list-style-type: none;\n  padding: 0;\n}\n\n.region ul li {\n  font-size: 1em;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.region ul li span {\n  font-weight: bold;\n}\n.color-box {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  margin-right: 10px;\n  border: 1px solid #000;\n}\n\nbutton {\n  margin-left: 10px;\n  padding: 5px 10px;\n  border: none;\n  background-color: #57687a;\n  color: rgb(0, 0, 0);\n  cursor: pointer;\n  border-radius: 4px;\n}\n\nbutton:hover {\n  background-color: #00b395;\n}\n\n.clear-button {\n  margin-left: 10px;\n  padding: 5px 10px;\n  border: none;\n  background-color: #dc3545;\n  color: white;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.clear-button:hover {\n  background-color: #c82333;\n}\n\n.selected-regions {\n  margin-top: 20px;\n}\n\n.selected-regions h2 {\n  font-size: 1.2em;\n  margin-bottom: 10px;\n}\n\n.selected-regions ul {\n  list-style-type: none;\n  padding: 0;\n}\n\n.selected-regions ul li {\n  margin-bottom: 5px;\n}\n\n.back-button {\n  margin-bottom: 10px;\n  padding: 5px 10px;\n  border: none;\n  background-color: #007bff;\n  color: white;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.back-button:hover {\n  background-color: #0056b3;\n}\n\n.region-list-container {\n  padding: 20px;\n  background-color: #000000;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin-top: 20px;\n}\n\n.region-list-container button {\n  margin-bottom: 10px;\n  padding: 10px 20px;\n  border: none;\n  background-color: #c97611;\n\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.region-list-container button:hover {\n  background-color: #0056b3;\n}\n\n.region-list-container h2 {\n  font-size: 1.5em;\n  margin-bottom: 10px;\n  color: #ffffff;\n}\n\n.region-list {\n  list-style-type: none;\n  padding: 0;\n}\n\n.region-list li {\n  font-size: 1.2em;\n  margin-bottom: 5px;\n  padding: 10px;\n  background-color: #2b2929;\n  border-radius: 4px;\n  box-shadow: 0 2px 4px rgba(39, 12, 12, 0.1);\n}\n\n.region-info {\n  padding: 20px;\n  background-color: #6c4646;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin-top: 20px;\n}\n\n.region-info button {\n  margin-bottom: 10px;\n  padding: 10px 20px;\n  border: none;\n  background-color: #320306;\n  color: white;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.region-info button:hover {\n  background-color: #a85470;\n}\n\n.region-info h2 {\n  font-size: 2em;\n  margin-bottom: 10px;\n  color: #0c0000;\n}\n\n.region-info p {\n  font-size: 1.2em;\n  color: #000000;\n  line-height: 1.5;\n}\n\n.filter-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 80%; /* Matches slider width */\n  margin: 10px auto;\n  gap: 10px;\n}\n\n.filter-label {\n  font-size: 16px;\n  font-weight: bold;\n  color: #000000;\n}\n\n.filter-dropdown {\n  flex: 1; /* Makes it take the same width as the slider */\n  min-width: 150px;\n}\n\n.button-group {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px; /* Space between buttons */\n  margin: 10px auto;\n  width: 100%;\n}\n\n.zoom-button {\n  flex: 1; /* Equal width for all buttons */\n  min-width: 120px; /* Ensures buttons are not too small */\n  text-transform: none; /* Keeps text as entered (not uppercase) */\n  font-size: 12px;\n  font-weight: 500;\n  padding: 8px 12px;\n}\n.table-filter-container {\n  display: flex;\n  justify-content: flex-end; /* Align filter to the right */\n  margin-bottom: 10px;\n}\n\n.table-filter-dropdown {\n  min-width: 150px;\n}\n/* Help Modal Styling */\n.help-modal-container {\n  width: 30%;\n  margin: 5% auto;\n  background-color: white;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\n  max-height: 80vh;\n  overflow-y: auto;\n  text-align: left;\n \n}\n\n/* Modal Header */\n.help-modal-container h5 {\n  text-align: center;\n  margin-bottom: 15px;\n  color: #000000;\n  font-weight: bold;\n}\n\n/* Modal Sections */\n.help-modal-container h6 {\n  margin-top: 20px;\n  color: #007bff;\n  font-weight: bold;\n}\n\n/* Bullet Points */\n.help-modal-container ul {\n  padding-left: 20px;\n  margin: 10px 0;\n}\n\n.help-modal-container li {\n  margin-bottom: 8px;\n  font-size: 16px;\n  color: #000000;\n}\n\n/* Close Button */\n.help-modal-close {\n  text-align: right;\n  margin-top: 15px;\n}\n\n.help-modal-close button {\n  background-color: #d32f2f;\n  color: white;\n  font-weight: bold;\n  padding: 8px 16px;\n  border-radius: 5px;\n  border: none;\n  cursor: pointer;\n  transition: background 0.3s ease-in-out;\n}\n\n.help-modal-close button:hover {\n  background-color: #b71c1c;\n}\n.purified-button {\n  background-color: #183792; /* Green background */\n  color: white;\n  padding: 15px 60px;\n  border: none;\n  border-radius: 6px;\n  font-size: 15px;\n  cursor: pointer;\n  margin-top: 10px;\n  display: block;\n}\n\n.forecast {\n  background-color: #d600a8;\n  color: white;\n  padding: 15px 70px;\n  border: none;\n  border-radius: 6px;\n  font-size: 15px;\n  cursor: pointer;\n  margin-top: 10px;\n  display: block;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
